import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import CommercialSuppliersApi from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener comerciales',
  })
}

const useCommercialSuppliers = () => {
  const { data, isLoading, refetch } = useQuery(
    [QUERY_KEYS.COMMERCIAL_SUPPLIERS],
    CommercialSuppliersApi.getCommercialSuppliers,
    {
      staleTime: 30000,
      onError,
    },
  )

  return {
    commercialSuppliers: data?.commercialSuppliers ?? [],
    total: data?.total ?? 0,
    isLoading,
    refetch,
  }
}

export default useCommercialSuppliers
